'use client'

import { Fragment, useMemo } from 'react'
import {
  Breadcrumb,
  BreadcrumbSeparator,
  BreadcrumbList,
  BreadcrumbItem,
} from '@anytimefitness/pb-react-ui'
import { usePathname } from 'next/navigation'
import { useSelectedStudioStore } from '@/stores/selected-studio-store'
import { formatStudioDisplayName } from '@/utils/studios'
import { sidebarContent } from '../app-sidebar/app-sidebar'

interface BreadcrumbEntry {
  title: string
  url: string
}

export default function HeaderBreadcrumbs() {
  const pathName = usePathname()
  const selectedStudio = useSelectedStudioStore((state) => state.selectedStudio)

  const breadcrumbList = useMemo(() => {
    const entries: BreadcrumbEntry[] = []

    if (selectedStudio) {
      entries.push({
        title: formatStudioDisplayName(
          selectedStudio.license_number,
          selectedStudio.name
        ),
        url: '/',
      })
    }

    if (pathName === '/') {
      entries.push({ title: 'Home', url: '/' })
    } else {
      const pageCrumbs = sidebarContent.reduce(
        (acc: BreadcrumbEntry[], { title, items }) => {
          const foundPage = items.find(({ url }) => url === pathName)

          if (foundPage) {
            acc.push(
              { title, url: '/' },
              { title: foundPage.title, url: foundPage.url }
            )
          }

          return acc
        },
        []
      )
      entries.push(...pageCrumbs)
    }

    return entries
  }, [selectedStudio, pathName])

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbList.map(({ title }, i, arr) => (
          <Fragment key={title}>
            <BreadcrumbItem>{title}</BreadcrumbItem>
            {i < arr.length - 1 && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
